//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { IReferenceType, IOpObject, IOpChangeState } from "../util/interfaces"

import { Enums } from "../common/enums"

import { DataProvider } from "../../helpers/data-provider"
import { Dictionary } from "../../helpers/dictionary"
import { ConvertHelper } from "../../helpers"

import { OpConsumer } from "./op-consumer"
import { OpConsumerTransactionData } from "./op-consumer-transaction-data"
import { OpDataList } from "../util/op-data-list"
import { OpDataType } from "./op-data-type"
import { OpDistributor } from "./op-distributor"
import { OpOperator } from "./op-operator"



export class OpConsumerTransaction implements IReferenceType, IOpObject, IOpChangeState {

    //#region Properties

    public idConsumerTransaction: number
    public idConsumer: number
    public idOperator: number
    public idDistributor: number
    public idConsumerTransactionType: number
    public idTariff: number
    public transactionGuid: string
    public time: Date
    public chargePrepaid: number

    //#endregion


    //#region Navigation Properties

    public consumer: OpConsumer
    public operator: OpOperator
    public distributor: OpDistributor

    //#endregion


    //#region Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //#endregion


    //#region IOpChangeState implementation

    public opState: Enums.OpChangeState

    //#endregion


    //#region IReferenceType implementation

    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdConsumer
    }

    public getReferenceKey(): number {
        return this.idConsumerTransaction
    }

    public getReferenceValue(): any {
        return this
    }

    //#endregion


    //#region IOpObject implementation

    public get idObject(): any {
        return this.idConsumerTransaction
    }
    public set idObject(idObject: any) {
        this.idConsumerTransaction = idObject
    }

    public dataList: OpDataList<OpConsumerTransactionData> = new OpDataList<OpConsumerTransactionData>()

    public dynamicValues: { Key: string, Value: any }[] = []

    public customFormatString: string;

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idConsumerTransaction = opObj.ID_CONSUMER_TRANSACTION
            this.idConsumerTransactionType = opObj.ID_CONSUMER_TRANSACTION_TYPE
            this.idConsumer = opObj.ID_CONSUMER
            this.idOperator = opObj.ID_OPERATOR
            this.idDistributor = opObj.ID_DISTRIBUTOR
            this.idTariff = opObj.ID_TARIFF
            this.transactionGuid = opObj.TRANSACTION_GUID
            this.time = opObj.TIME != null ? ConvertHelper.stringToDate(opObj.TIME) : null
            this.chargePrepaid = opObj.CHARGE_PREPAID

            this.dynamicValues = opObj.dynamicValues
            this.opState = opObj.OpState

            if (opObj.DataList) {
                this.dataList.push(...opObj.DataList.map(data => new OpConsumerTransactionData(data)))
            }

            this.consumer = opObj._Consumer != null ? new OpConsumer(opObj._Consumer != null) : null
            this.operator = opObj._Operator != null ? new OpOperator(opObj._Operator != null) : null
            this.distributor = opObj._Distributor != null ? new OpDistributor(opObj._Distributor != null) : null
        } else {
            this.idConsumerTransaction = 0
            this.opState = Enums.OpChangeState.New
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_CONSUMER_TRANSACTION: this.idConsumerTransaction,
            ID_CONSUMER_TRANSACTION_TYPE: this.idConsumerTransactionType,
            ID_CONSUMER: this.idConsumer,
            ID_OPERATOR: this.idOperator,
            ID_DISTRIBUTOR: this.idDistributor,
            ID_TARIFF: this.idTariff,
            TIME: this.time != null ? ConvertHelper.dateToString(this.time) : null,
            CHARGE_PREPAID: this.chargePrepaid,

            DataList: this.dataList ? this.dataList.ToJSON() : null,
            OpState: this.opState,
        }
    }

    public toString(): string {
        return this.transactionGuid
    }

    //#endregion


    public static loadNavigationProperties(dataProvider: DataProvider, list: OpConsumerTransaction[]): JQueryPromise<OpConsumerTransaction[]> {
        var defered = $.Deferred<OpConsumerTransaction[]>()

        if (dataProvider && list && list.length > 0) {
            dataProvider.System.getDictionaries([Enums.ReferenceType.IdDataType]).then(dict => {
                var dataTypeDict: Dictionary<OpDataType> = new Dictionary<OpDataType>(null)
                if (dict.containsKey(Enums.ReferenceType.IdDataType)) {
                    dataTypeDict = <Dictionary<OpDataType>>dict.tryGetValue(Enums.ReferenceType.IdDataType)
                }

                list.forEach(item => {
                    if (item.dataList) {
                        item.dataList
                            .toArray()
                            .forEach((data: OpConsumerTransactionData) => {
                                data.dataType = dataTypeDict.tryGetValue(data.idDataType)
                            })
                    }
                })
                defered.resolve(list)
            })
        } else {
            defered.resolve(list)
        }

        return defered.promise()
    }
}